<template>
  <main
    id="js-page-content"
    role="main"
    class="page-content"
    :class="{
      isEdit: isEditMode,
    }"
  >
    <div class="row lockHeader shinseisyoHeader">
      <div class="subheader col-md-6">
        <h1 class="subheader-title">
          経費精算書
          <sup
            v-if="delegate.request.c_request_status == 4"
            class="badge badge-dark fw-400 l-h-n"
            >取下</sup
          >
          <sup
            v-if="
              delegate.request.c_request_status == 0 ||
              delegate.request.c_request_status == 5
            "
            class="badge badge-warning fw-400 l-h-n"
            >未申請</sup
          >
          <sup
            v-if="delegate.request.c_request_status == 1"
            class="badge badge-info fw-400 l-h-n"
            >申請中</sup
          >
          <sup
            v-if="delegate.request.c_request_status == 3"
            class="badge badge-success fw-400 l-h-n"
            >承認済</sup
          >
          <sup
            v-if="delegate.request.c_request_status == 2"
            class="badge badge-danger fw-400 l-h-n"
            >差戻</sup
          >
        </h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div
        class="subheader-block ml-auto demo col-md-6"
        style="text-align: right"
      >
        <template v-if="delegate.c_request_expenses_id != null">
          <button
            type="button"
            class="btn btn-info waves-effect waves-themed"
            :disabled="btnDisable"
            v-if="rewriteFlg"
            @click="reriteConf()"
          >
            <span class="fal fa-undo-alt mr-1"></span>再編集
          </button>
          <template
            v-if="
              delegate.docfile != null &&
              delegate.docfile.url4Show != null &&
              delegate.docfile.url4Show != ''
            "
          >
            <button
              type="button"
              class="btn btn-primary waves-effect waves-themed"
              :disabled="btnDisable"
              @click="showModal4Receipt()"
            >
              <span class="fal fa-file-invoice-dollar mr-1"></span>領収書
            </button>
          </template>
          <template v-else>
            <button
              type="button"
              class="btn btn-warning waves-effect waves-themed"
              :disabled="btnDisable"
              @click="showModal4Receipt()"
            >
              <span class="fal fa-file-invoice-dollar mr-1"></span>領収書未登録
            </button>
          </template>
        </template>
        <button
          type="button"
          class="btn btn-primary waves-effect waves-themed keihiseisansyoExDl"
          :disabled="btnDisable"
          v-if="delegate.request.c_request_status != 2 && isShowExportBtn()"
          @click="dl()"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button>
        <button
          type="button"
          v-if="!isEditMode && delegate.request.c_request_status == null"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="add()"
        >
          <span class="fal fa-check mr-1"></span>一時保存
        </button>
        <button
          type="button"
          v-if="
            ((!isEditMode && isMine) ||
              isAdmin ||
              (isRewriteMisinsei &&
                isLoginUserApproval &&
                isLoginUserSettingApprovalUser) ||
              (isRewriteMisinsei &&
                isMine &&
                !isLoginUserSettingApprovalUser)) &&
            (delegate.request.c_request_status == 0 ||
              delegate.request.c_request_status == 5)
          "
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="approvalRequest()"
        >
          <span class="fal fa-check mr-1"></span>承認申請
        </button>
        <button
          type="button"
          @click="updNormal(false)"
          v-if="
            !isEditMode &&
            (delegate.request.c_request_status == 0 ||
              delegate.request.c_request_status == 2 ||
              delegate.request.c_request_status == 5)
          "
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>

        <button
          type="button"
          v-if="
            (isEditMode &&
              !isRewriteMisinsei &&
              isMine &&
              delegate.request.c_request_status != 4) ||
            (isMine && delegate.request.c_request_status == 2)
          "
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="disableConf()"
        >
          <span class="fal fa-check mr-1"></span>取下
        </button>
        <button
          type="button"
          v-if="
            (isEditMode && isAdmin) ||
            (isMine &&
              delegate.request.c_request_status == 0 &&
              !isRewriteMisinsei) ||
            (isMine &&
              delegate.request.c_request_status == 5 &&
              isRewriteMisinsei &&
              !isLoginUserSettingApprovalUser) ||
            (!isMine &&
              delegate.request.c_request_status == 5 &&
              isRewriteMisinsei &&
              isLoginUserApproval)
          "
          :disabled="btnDisable"
          class="btn btn-danger waves-effect waves-themed"
          @click="delConf()"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/shinseisyolist')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <div class="lockHeaderSpacer">　</div>
    <!-- Your main content goes below here: -->
    <!-- 承認処理待ちメッセージ -->
    <div class="alert alert-danger" v-if="fmShowConf">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">あなたが承認者です</span>
            <p>
              この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。
            </p>
            <p class="m-0">
              <button
                type="button"
                class="btn btn-info waves-effect waves-themed"
                @click="upd4Approval(true)"
              >
                <span class="fal fa-check mr-1"></span>承認
              </button>
              <span style="width: 20px"> 　</span>
              <button
                type="button"
                class="btn btn-danger waves-effect waves-themed"
                @click="upd4Approval(false)"
              >
                <span class="fal fa-times mr-1"></span>差戻
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認処理待ちメッセージ -->
    <div class="alert alert-primary" v-if="fmShowConfEx">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この申請書は承認依頼中です</span>
            <p>
              この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認処理待ちメッセージ -->
    <!-- 差し戻しメッセージ -->
    <div class="alert alert-danger" v-if="fmShowSasimodosi">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この申請書は差し戻しされました</span>
            <p>
              この申請書は承認権者により差し戻しされています。差し戻し理由を確認の上、この申請書を修正して、再度承認申請を出してください。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 差し戻しメッセージ -->
    <!-- 取り下げメッセージ -->
    <div class="alert alert-primary" v-if="fmShowTorisage">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この申請書は取り下げられました</span>
            <p>
              この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 取り下げメッセージ -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>申請時用</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請番号</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaCd"
                        class="form-control form-control-sm"
                        v-model="delegate.request.c_request_id"
                        disabled
                      />
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">管理名</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="xxxx案件でyyyy作業の為"
                        :disabled="isEditMode"
                        v-model="delegate.request.c_request_name"
                      />
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請日時</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          convDateTime(delegate.request.c_request_datetime)
                        "
                        disabled
                      />
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請者</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <template v-if="isAdmin && !isEditMode">
                        <!-- 管理者用 入力モード用 -->
                        <vSelect
                          :options="getOpStaffs()"
                          label="c_staff_name"
                          v-model="delegate.request.c_staff_id"
                          :reduce="(label:any) => label.c_staff_id"
                        ></vSelect>
                      </template>
                      <template v-else>
                        <!-- 管理者以外用 -->
                        <input
                          type="text"
                          name="txtKouzaCd"
                          class="form-control form-control-sm"
                          disabled
                          v-model="domApplicantName"
                        />
                      </template>
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div
                class="row"
                style="
                  border-top: 1px solid #e5e5e5;
                  padding-top: 10px;
                  margin-bottom: 0;
                "
              >
                <div class="col-md-1 contTitle">起案日</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="date"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        maxlength="10"
                        :disabled="isEditMode"
                        v-model="domStartDate"
                      />
                      <div
                        v-if="errors?.path === 'startDate'"
                        class="error-message4vali"
                      >
                        {{ errors.message }}
                      </div>
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <!-- <div class="row">
                <div class="col-md-1 contTitle">部署名</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <vSelect
                        :options="optionsOp2"
                        :reduce="(label:any) => label.code"
                      ></vSelect>
                    </div>
                    <div class="1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div> -->
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">仮払金</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <Mo_CurrencyInput
                        v-model="domTmppay_price"
                        class="form-control form-control-sm"
                        style="text-align: right"
                        :decimal-places="0"
                        :allow-negative="false"
                        :showValue="true"
                        :disabled="isEditMode"
                      />
                      <span> </span>
                      <div
                        v-if="errors?.path === 'tmppayPrice'"
                        class="error-message4vali"
                      >
                        {{ errors.message }}
                      </div>
                      <div
                        class="icon-stack icon-stack-lg"
                        :class="{
                          notZeroTmppay:
                            domTmppay_price != null && domTmppay_price > 0,
                        }"
                        style="display: none; color: red; font-size: 12px"
                      >
                        <i
                          class="fal fa-info-circle"
                          style="font-size: 16px; margin-right: 5px"
                        ></i
                        >仮払金に間違いないかご確認ください
                      </div>
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <!-- <div class="row">
                <div class="col-md-1 contTitle">精算金額</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        maxlength="50"
                        onfocus="kanmaDel(this)"
                        onblur="kanmaIns(this)"
                        style="text-align: right"
                        :disabled="isEditMode"
                        v-model="domPay_price"
                      />
                      <div
                        v-if="errors?.path === 'payPrice'"
                        class="error-message4vali"
                      >
                        {{ errors.message }}
                      </div>
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div> -->
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">第一承認</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaNumber"
                        class="form-control form-control-sm"
                        v-bind:value="getAuthoriser(1)"
                        disabled
                      />
                    </div>

                    <div class="col-md-2 contTitle">承認日時</div>
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          getAuthDate(
                            delegate.request.c_request_1_approval,
                            delegate.request.c_request_1_approval_datetime
                          )
                        "
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">第二承認</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaNumber"
                        class="form-control form-control-sm"
                        v-bind:value="getAuthoriser(2)"
                        disabled
                      />
                    </div>

                    <div class="col-md-2 contTitle">承認日時</div>
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          getAuthDate(
                            delegate.request.c_request_2_approval,
                            delegate.request.c_request_2_approval_datetime
                          )
                        "
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">最終承認</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaNumber"
                        class="form-control form-control-sm"
                        v-bind:value="getAuthoriser(3)"
                        disabled
                      />
                    </div>

                    <div class="col-md-2 contTitle">承認日時</div>
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          getAuthDate(
                            delegate.request.c_request_3_approval,
                            delegate.request.c_request_3_approval_datetime
                          )
                        "
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-lg-6 contCnt">
                  <table class="tb_list">
                    <tr>
                      <td class="tb_title" colspan="2" rowspan="8" x:str="">
                        区分
                      </td>
                      <td x:num="1" class="tb_num">1</td>
                      <td colspan="3" x:str="" class="tb_name">旅費交通費</td>
                      <td colspan="13" x:str="" class="tb_det">
                        公共交通機関の利用費・駐車場代・宿泊費など。
                      </td>
                    </tr>
                    <tr>
                      <td x:num="2" class="tb_num">2</td>
                      <td colspan="3" x:str="" class="tb_name">交際費</td>
                      <td colspan="13" x:str="" class="tb_det">
                        酒類をともなう飲食代。<span
                          style="color: #a92828; font-weight: bold"
                          >一人あたり</span
                        >飲食代（税抜5,000円超）、贈答品など。
                      </td>
                    </tr>
                    <tr>
                      <td x:num="3" class="tb_num">3</td>
                      <td colspan="3" x:str="" class="tb_name">会議費</td>
                      <td colspan="13" x:str="" class="tb_det">
                        喫茶代。<span style="color: #a92828; font-weight: bold"
                          >一人あたり</span
                        >飲食代（税抜5,000円以下）
                      </td>
                    </tr>
                    <tr>
                      <td x:num="4" class="tb_num">4</td>
                      <td colspan="3" x:str="" class="tb_name">通信費</td>
                      <td colspan="13" x:str="" class="tb_det">
                        電話代・通信料・郵便代・切手・葉書代・宅配業者、バイク便など。
                      </td>
                    </tr>
                    <tr>
                      <td x:num="5" class="tb_num">5</td>
                      <td colspan="3" x:str="" class="tb_name">租税公課</td>
                      <td colspan="13" x:str="" class="tb_det">
                        収入印紙代、証紙代
                      </td>
                    </tr>
                    <tr>
                      <td x:num="6" class="tb_num">6</td>
                      <td colspan="3" x:str="" class="tb_name">消耗品費</td>
                      <td colspan="13" x:str="" class="tb_det">
                        備品・事務用品・ガソリン代など。
                      </td>
                    </tr>
                    <tr>
                      <td x:num="7" class="tb_num">7</td>
                      <td colspan="3" x:str="" class="tb_name">原価算入</td>
                      <td colspan="13" x:str="" class="tb_det">
                        売上に関する仕入など。
                      </td>
                    </tr>
                    <tr>
                      <td x:num="8" class="tb_num">8</td>
                      <td colspan="3" x:str="" class="tb_name">その他</td>
                      <td colspan="13" x:str="" class="tb_det">
                        上記にあてはまらいないもの。
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-lg-6 contCnt">
                  <table class="tb_list">
                    <tr>
                      <td class="tb_title" colspan="2" rowspan="8" x:str="">
                        インボイス
                      </td>
                      <td colspan="2" x:str="" class="tb_name">T</td>
                      <td colspan="14" x:str="" class="tb_det">
                        登録番号あり。（法人番号を取得しているからと言って、登録番号申請をしているとは限りません。
                        個人経営店などは、個人名で番号取得している可能性があり、事後のネット検索は不可能です）
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" x:str="" class="tb_name">特例</td>
                      <td colspan="14" x:str="" class="tb_det">
                        3万円未満の少額取引、電車代、出張費など。（ただし、一枚領収書で3万円以上は登録番号が必要）
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" x:str="" class="tb_name">なし</td>
                      <td colspan="14" x:str="" class="tb_det">
                        登録番号を未取得もしくは、不明。
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" x:str="" class="tb_name">８％</td>
                      <td colspan="14" x:str="" class="tb_det">
                        軽減税率８％の購入。（持ち帰り軽食、飲料、新聞代など）
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" x:str="" class="tb_name">０％</td>
                      <td colspan="14" x:str="" class="tb_det">
                        証紙代、印紙代、保険料。もしくは、参加費、会費で消費税明記がない場合。海外での精算。
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-------------------->
              <div class="row justify-content-between">
                <div class="col-auto contTitle" style="text-align: left">
                  【課税対象】
                </div>
                <div class="col-auto contTitle" style="text-align: right">
                  （単位：円／税込）
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">国税庁リンク</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-7 contCnt">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="13桁半角数字で登録番号を入力してください"
                        v-model="domRegistNum"
                      />
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary waves-effect waves-themed"
                      style="height: 30px"
                      :disabled="btnDisable"
                      @click="goToTaxSite()"
                    >
                      検索
                    </button>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col contCnt">
                  <div class="demo" style="overflow: auto">
                    <table
                      class="table table-sm table-bordered m-0 tableKeihi"
                      style="min-width: 1200px"
                      :class="{
                        isEdit: isEditMode,
                      }"
                    >
                      <thead class="bg-primary-400">
                        <tr>
                          <th
                            id="sort4DateHead"
                            class="fixhead headKeihi cwK_1"
                            @click="sortRow4Date()"
                          >
                            使用月日
                            <i
                              id="sort4DateUp"
                              class="fal fa-sort-amount-up dispNone"
                            ></i>
                            <i
                              id="sort4DateDown"
                              class="fal fa-sort-amount-down"
                            ></i>
                          </th>
                          <th class="fixhead headKeihi cwK_2">区分</th>
                          <th class="fixhead headKeihi cwK_3">支払先</th>
                          <th class="fixhead headKeihi cwK_4">目的</th>
                          <th class="fixhead headKeihi cwK_5">人数</th>
                          <th class="fixhead headKeihi cwK_6">金額/税込</th>
                          <th
                            id="sort4InvoiceHead"
                            class="fixhead headKeihi cwK_7"
                            @click="sortRow4invoice()"
                          >
                            インボイス
                            <i
                              id="sort4InvoiceUp"
                              class="fal fa-sort-amount-up dispNone"
                            ></i>
                            <i
                              id="sort4InvoiceDown"
                              class="fal fa-sort-amount-down"
                            ></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- ------------------- -->
                        <Mo_expenses_row
                          v-for="item in expensesList"
                          :key="item.c_expenses_rownum!"
                          v-bind:item="item"
                          v-bind:isDisable="isDisableExpensesList"
                          class="tb_input"
                          @reCalc="sumCalc()"
                        ></Mo_expenses_row>
                        <!-- ------------------- -->
                      </tbody>
                      <!-- ------------------- -->
                      <tfoot>
                        <tr>
                          <th
                            colspan="5"
                            class="bg-primary-400"
                            style="text-align: center"
                          >
                            合計金額（税込）
                          </th>
                          <td class="keihiCont">
                            <input
                              type="text"
                              maxlength="50"
                              style="text-align: right"
                              v-model="domSumPrice"
                              readonly
                            />
                          </td>
                        </tr>
                      </tfoot>
                      <!-- ------------------- -->
                    </table>
                  </div>
                </div>
              </div>
              <!-------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 領収書モーダル -->
    <Mo_modal_right_l ref="Mo_modal_receipt">
      <template v-slot:title>
        <div id="header4Recept">
          領収書
          <div style="width: 230px; position: absolute; right: 60px; top: 15px">
            <button
              type="button"
              id="btnOpenRecept"
              class="btn-sm btn-primary waves-effect waves-themed"
              :disabled="
                btnDisable ||
                delegate.docfile == null ||
                delegate.docfile.url4Show == null ||
                delegate.docfile.url4Show == ''
              "
              @click="openRecept()"
            >
              <span class="fal fa-download mr-1"></span>ダウンロード
            </button>
            <button
              type="button"
              id="btnOpenRecept"
              class="btn-sm btn-primary waves-effect waves-themed"
              style="margin-left: 10px"
              :disabled="
                btnDisable ||
                delegate.docfile == null ||
                delegate.request.c_request_status != 3
              "
              @click="goTo('/docedit?id=' + delegate.docfile.c_doc_id, $event)"
            >
              <span class="fal fa-external-link-square mr-1"></span>文書詳細
            </button>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div id="body4Recept" class="panel-container">
          <div class="loader">
            <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
          </div>

          <!-- 自身の経費精算書もしくは、管理者の場合、領収書をアップロード可能とする -->
          <template
            v-if="
              (isEditMode && isAdmin) ||
              (isMine && !isRewriteMisinsei) ||
              (isMine &&
                isRewriteMisinsei &&
                !isLoginUserSettingApprovalUser) ||
              (!isMine && isRewriteMisinsei && isLoginUserApproval)
            "
          >
            <div
              id="dzFlame"
              style="width: 100%; height: 150px; background-color: white"
            >
              <dropzone
                :fileInfo="fileInfo"
                :updateFileInfo="updateFileInfo"
                :isMinMode="true"
              ></dropzone>
            </div>
          </template>
          <template v-else>
            <div class="alert alert-warning" role="alert">
              領収書のアップロードは、自身の経費精算書でのみ可能です。
            </div>
          </template>
          <!-- 自身の経費精算書もしくは、管理者の場合、領収書をアップロード可能とする -->

          <div class="col-md-12 contTitle">
            <div
              id="frame-img"
              style="
                box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
                margin: 15px;
                width: 90%;
                margin: 0 auto;
                margin-top: 20px;
                overflow: hidden;
              "
            >
              <template
                v-if="
                  delegate.docfile != null &&
                  delegate.docfile.url4Show != null &&
                  delegate.docfile.url4Show != '' &&
                  showReceptImg
                "
              >
                <Or_pdfviewer :item="delegate.docfile"></Or_pdfviewer>
              </template>
              <template v-else>
                <div
                  id="frame-img4None"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    max-width: 400px;
                    width: 90%;
                    min-height: 420px;
                    margin: 0 auto;
                  "
                >
                  <div>
                    <div
                      v-if="
                        delegate.docfile != null &&
                        delegate.docfile.url4Show != null &&
                        delegate.docfile.url4Show != ''
                      "
                      style="text-align: center; color: #3b31a1"
                      class="h2"
                    >
                      画像読み込み中・・・
                    </div>
                    <div
                      v-else
                      style="text-align: center; color: #3b31a1"
                      class="h2"
                    >
                      領収書が登録されていません
                    </div>
                    <div>
                      <img
                        src="/img/backgrounds/imgloading.svg"
                        alt=""
                        style="width: 100%"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div id="footer4Recept" class="modal-footer">
          <button
            :disabled="btnDisable"
            type="button"
            class="btn btn-secondary waves-effect waves-themed"
            @click="closeModal4Receipt()"
          >
            <span class="fal fa-reply mr-1"></span>閉じる
          </button>
        </div>
      </template>
    </Mo_modal_right_l>
    <!-- 領収書モーダル -->
    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 再編集確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_rewiteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalRewriteConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="rewrite()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4RewriteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 再編集確認モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- 取下確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_disableConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDisableConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="disab()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4disableConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 取下確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_common } from "@/functions/Cl_common";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import Mo_modal_right_l from "@/components/molecules/Mo_modal_right_l.vue";
import {
  CONST_APPROVAL_STATUS_SYOUNIN,
  CONST_REQUEST_STATUS_MISINSEI,
  CONST_REQUEST_STATUS_SASIMODOSI,
  CONST_REQUEST_STATUS_SINSEITYU,
  CONST_REQUEST_STATUS_SYOUNINZUMI,
  CONST_REQUEST_STATUS_TORISAGE,
  CONST_REQUEST_TYPE_KEIHISEISAN,
  CONST_DOC_TYPE_RYOUSYUSYO,
  CONST_REQUEST_STATUS_MISINSEI_REWRITE,
} from "furukawa-common/src/common/constant/Constants";

// masters
import { Cl_master } from "@/functions/Cl_master";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";

//経費清算
import { Cl_requestexpenses } from "@/functions/Cl_requestexpenses";
import { DtoRequestExpensessGetReqImple } from "furukawa-common/src/common/dto/DtoRequestExpensessGetReqImple";
import { DtoRequestExpensessGetResImple } from "furukawa-common/src/common/dto/DtoRequestExpensessGetResImple";
import { DtoRequestExpensessPutReqImple } from "furukawa-common/src/common/dto/DtoRequestExpensessPutReqImple";
import { DtoRequestExpensessPostResImple } from "furukawa-common/src/common/dto/DtoRequestExpensessPutResImple";
import { DtoRequestExpensessPostReqImple } from "furukawa-common/src/common/dto/DtoRequestExpensessPostReqImple";
import { DtoRequestOvertimesPostResImple } from "furukawa-common/src/common/dto/DtoRequestOvertimesPostResImple";
import { EntityRequestExpensesList } from "furukawa-common/src/common/entity/EntityRequestExpensesList";
import Mo_expenses_row from "@/components/molecules/Mo_expenses_row.vue";

//申請ヘッダ
import { Cl_request } from "@/functions/Cl_request";
import { DtoRequestsPutReqImple } from "furukawa-common/src/common/dto/DtoRequestsPutReqImple";
import { DtoRequestsPutResImple } from "furukawa-common/src/common/dto/DtoRequestsPutResImple";

//store
import store from "@/store";
import { CommonStaff } from "furukawa-common/src/common/service/CommonStaff";

// バリデーション
import * as Yup from "yup";
import { Cl_filemaster } from "@/functions/Cl_filemaster";
import { DtoFileMastersGetReqImple } from "furukawa-common/src/common/dto/DtoFileMastersGetReqImple";
import { EntityStaff } from "furukawa-common/src/common/entity/EntityStaff";

// ファイル
import dropzone from "@/components/organisms/Or_fileupload.vue";
import Or_pdfviewer from "@/components/organisms/Or_pdfviewer.vue";
import axios from "axios";
import { Cl_doc } from "@/functions/Cl_doc";
import { DtoDocsPostReqImple } from "furukawa-common/src/common/dto/DtoDocsPostReqImple";
import { DtoDocsPutReqImple } from "furukawa-common/src/common/dto/DtoDocsPutReqImple";

import Mo_CurrencyInput from "@/components/molecules/Mo_CurrencyInput.vue";
import { DtoStaffsGetReqImple } from "furukawa-common/src/common/dto/DtoStaffsGetReqImple";
import { Cl_staff } from "@/functions/Cl_staff";
import { DtoStaffsGetResImple } from "furukawa-common/src/common/dto/DtoStaffsGetResImple";

@Options({
  components: {
    vSelect,
    Mo_modal_alert,
    Mo_expenses_row,
    Mo_modal_right_l,
    dropzone,
    Or_pdfviewer,
    Mo_CurrencyInput,
  },
})
export default class shinsei_Keihiseisanedit extends Vue {
  //----------------------
  //バリデーション
  //----------------------
  //スキーマ宣言
  schemaAdd = Yup.object().shape({
    startDate: Yup.string().required("起案日を入力してください"),
  });

  schemaAdd_tmppayprice = Yup.object().shape({
    tmppayPrice: Yup.number()
      .nullable()
      .required("仮払金を半角数字で入力してください")
      .typeError("仮払金を半角数字で入力してください"),
  });

  // schemaAdd_payprice = Yup.object().shape({
  //   payPrice: Yup.number()
  //     .nullable()
  //     .required("精算金額を半角数字で入力してください")
  //     .typeError("精算金額を半角数字で入力してください"),
  // });

  //エラー格納用
  errors: Yup.ValidationError | null = null;
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoRequestExpensessGetResImple();
  delegate4list = new DtoMastersGetRes();
  expensesList: EntityRequestExpensesList[] = [];
  isDisableExpensesList = true;
  staffMaster = new DtoStaffsGetResImple();

  btnDisable = false;
  isAdmin = false;
  isMine = false;
  isEditMode = true;
  showReceptImg = true;
  // 再編集ボタン押下可能フラグ
  rewriteFlg = false;
  // 対象データが再編集ボタンを押されて未申請となったものかどうか
  isRewriteMisinsei = false;
  // ログインユーザーが申請承認1～3に該当する
  isLoginUserApproval = false;
  // ログインユーザーに申請承認1～3が設定されているか
  isLoginUserSettingApprovalUser = false;

  domApplicantName = "";
  domContent = "";
  domSumPrice = "";
  domTmppay_price = 0;
  domPay_price = "";
  domRegistNum = "";

  //ソートの向き
  isDescSort4Invoice = true;
  isDescSort4Date = true;

  //日付関係
  domStartDate: string | undefined = ""; //delegate.c_request_overtime_ot_date

  //承認フォームの表示非表示フラグ
  fmShowConf = false;
  fmShowConfEx = false;
  fmShowSasimodosi = false;
  fmShowTorisage = false;

  //新規時のファイル用
  //-------
  fileInfo: {
    path: string;
    name: string;
    size: number;
    type: string;
    lastMidified: number;
    data: any;
    isExcute: boolean;
  } = {
    path: "",
    name: "",
    size: -1,
    type: "",
    lastMidified: 0,
    data: null,
    isExcute: false,
  };

  //----------------------
  //DOM連携用メソッド
  //----------------------
  openRecept() {
    window.open(this.delegate.docfile!.url4Show!, "_blank");
  }
  /**
   * ファイルアップロードモーダルで処理されたデータの受け渡しに使用される。
   *
   * @param newFileInfo
   */
  updateFileInfo(newFileInfo: {
    path: string;
    name: string;
    size: number;
    type: string;
    lastMidified: number;
    data: any;
    isExcute: boolean;
  }) {
    this.fileInfo = newFileInfo;
  }
  convDateTime(val: Date | null): string {
    let res = "";

    if (val == null) {
      res = "";
    } else {
      res = val
        .toString()
        .replaceAll("-", "/")
        .replace("T", " ")
        .replace(".000Z", "");
    }

    return res;
  }

  /**
   * 承認者の順序を入力して、承認者名を得る
   * @param num
   */
  getAuthoriser(num: number): string {
    let res = "-";

    if (this.delegate4list.items4staffs == null) {
      return "-";
    }

    switch (num) {
      case 1:
        if (this.delegate.request.c_request_1_approval == null) {
          res = "-";
        } else {
          res = CommonStaff.cnvStaffNum2Name(
            this.delegate4list.items4staffs,
            this.delegate.request.c_request_1_approval
          );
        }

        break;
      case 2:
        if (this.delegate.request.c_request_2_approval == null) {
          res = "-";
        } else {
          res = CommonStaff.cnvStaffNum2Name(
            this.delegate4list.items4staffs,
            this.delegate.request.c_request_2_approval
          );
        }

        break;
      case 3:
        if (this.delegate.request.c_request_3_approval == null) {
          res = "-";
        } else {
          res = CommonStaff.cnvStaffNum2Name(
            this.delegate4list.items4staffs,
            this.delegate.request.c_request_3_approval
          );
        }

        break;
      default:
        break;
    }

    return res;
  }

  /**
   * 承認日時を受け取り、表示用の文字列にして返す
   * @param val
   */
  getAuthDate(authorizerId: number | null, val: Date | null): string {
    let res = "";

    if (authorizerId == null) {
      return "-";
    }

    if (val == null) {
      res = "未承認";
    } else {
      res = val
        .toString()
        .replaceAll("-", "/")
        .replace("T", " ")
        .replace(".000Z", "");
    }

    return res;
  }

  /**
   * 仕様月日列をソート
   */
  async sortRow4Date() {
    const elmUp = document.getElementById("sort4DateUp");
    const elmDown = document.getElementById("sort4DateDown");

    const compareInvoices = (
      a: { c_expenses_date: Date | null },
      b: { c_expenses_date: Date | null }
    ) => {
      // a または b が null の場合、後ろに配置
      if (a.c_expenses_date === null && b.c_expenses_date !== null) return 1;
      if (b.c_expenses_date === null && a.c_expenses_date !== null) return -1;

      // 両方とも null または 両方とも null でない場合の比較
      return this.isDescSort4Date
        ? new Date(b.c_expenses_date!).getTime() -
            new Date(a.c_expenses_date!).getTime()
        : new Date(a.c_expenses_date!).getTime() -
            new Date(b.c_expenses_date!).getTime();
    };

    // リストをソート
    this.expensesList.sort(compareInvoices);
    // this.expensesList[0].c_expenses_date
    // UIの更新
    if (this.isDescSort4Date) {
      elmUp?.classList.remove("dispNone");
      elmDown?.classList.add("dispNone");
    } else {
      elmUp?.classList.add("dispNone");
      elmDown?.classList.remove("dispNone");
    }

    // 昇順/降順フラグの切り替え
    this.isDescSort4Date = !this.isDescSort4Date;
  }
  /**
   * インボイス列をソート
   */
  async sortRow4invoice() {
    const elmUp = document.getElementById("sort4InvoiceUp");
    const elmDown = document.getElementById("sort4InvoiceDown");

    const compareInvoices = (
      a: { c_expenses_invoice: number | null },
      b: { c_expenses_invoice: number | null }
    ) => {
      // a または b が null の場合、後ろに配置
      if (a.c_expenses_invoice === null && b.c_expenses_invoice !== null)
        return 1;
      if (b.c_expenses_invoice === null && a.c_expenses_invoice !== null)
        return -1;

      // 両方とも null または 両方とも null でない場合の比較
      return this.isDescSort4Invoice
        ? b.c_expenses_invoice! - a.c_expenses_invoice!
        : a.c_expenses_invoice! - b.c_expenses_invoice!;
    };

    // リストをソート
    this.expensesList.sort(compareInvoices);

    // UIの更新
    if (this.isDescSort4Invoice) {
      elmUp?.classList.remove("dispNone");
      elmDown?.classList.add("dispNone");
    } else {
      elmUp?.classList.add("dispNone");
      elmDown?.classList.remove("dispNone");
    }

    // 昇順/降順フラグの切り替え
    this.isDescSort4Invoice = !this.isDescSort4Invoice;
  }

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  /**
   * 社員の選択肢を構築する用
   */
  getOpStaffs(): EntityStaff[] {
    return this.delegate4list.getStaffSortNum4NoneDelete([
      this.delegate.request.c_staff_id!,
    ]);
  }
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalDisableConf = "";
  message4ModalErrorConf = "";
  message4ModalRewriteConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getMastersList();
    await this.get();
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 合計金額の計算
   */
  async sumCalc() {
    // Cl_common.logger("sumCalc");

    let tmp = this.expensesList
      .reduce((acc, obj) => {
        // 文字列を数値に変換し、カンマを除去
        let value = obj.cnvPrice ? parseInt(obj.cnvPrice.replace(/,/g, "")) : 0;
        // isNaN関数で数値変換が正しく行われたかチェック
        if (isNaN(value)) {
          value = 0;
        }
        return acc + value;
      }, 0)
      .toString();

    while (tmp != (tmp = tmp.replace(/^(-?\d+)(\d{3})/, "$1,$2")));

    this.domSumPrice = tmp + "円";
  }

  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      dtoMaster.getStaff4sortNum = 1;
      dtoMaster.delFlag4Staff4sortNum = 1;
      dtoMaster.getStaff = 1;
      dtoMaster.delFlag4staff = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);

      // Cl_common.logger(this.delegate4list);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");
      store.commit("revStore");
      const authType = store.state.authType;
      // Cl_common.logger(authType);
      this.isAdmin = authType == 4; //管理者判定

      if (id == "") {
        //新規追加
        this.isEditMode = false;

        //初期値設定
        this.delegate.request.c_staff_id = store.state.id;
        // this.delegate.c_request_overtime_type = 1;
        this.fmShowConf = false;
        this.fmShowConfEx = false;

        let tmp: EntityRequestExpensesList;
        for (let index = 0; index < 30; index++) {
          tmp = new EntityRequestExpensesList();
          tmp.c_expenses_rownum = index + 1;
          await tmp.cnvData2dom();
          this.expensesList.push(tmp);
        }

        Cl_common.logger("this.expensesList");
        Cl_common.logger(this.expensesList);

        this.isDisableExpensesList = false;

        return;
      } else {
        //編集
        this.isEditMode = true;
        this.isDisableExpensesList = true;
      }

      //準備
      //-------
      let dto = new DtoRequestExpensessGetReqImple();

      //※fanctions内のクラスの修正コスト軽減の為、c_request_expenses_idに入れているが、
      //  API側ではrequestIDとして扱われるので注意
      dto.c_request_expenses_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_requestexpenses.get(dto);
      //レスポンス処理
      //-------
      //IDがnullなら一覧へ遷移
      if (this.delegate.c_request_expenses_id == null) {
        this.$router.push("/shinseisyolist");
        return;
      }

      //申請者の申請承認1～3を取得
      let staffDto = new DtoStaffsGetReqImple();
      staffDto.c_staff_id = this.delegate.request.c_staff_id;
      //API実行
      //-------
      this.staffMaster = await Cl_staff.get(staffDto);

      //UI連携用変数に入力
      //---
      await this.cnvData4Get();

      //フラグ更新
      //---
      store.commit("revStore");
      const loginStaffId = store.state.id;
      this.isMine = loginStaffId == this.delegate.request.c_staff_id!; //申請者判定

      //承認関係の表記
      //---
      await this.chgAuthCont();

      //一覧更新
      //---
      this.expensesList = JSON.parse(this.delegate.c_request_expenses_list!);

      this.updateLocalStatus();

      //ステータスが未申請なら編集可能に変更
      //---
      if (
        this.isMine &&
        this.delegate.request.c_request_status ==
          CONST_REQUEST_STATUS_SASIMODOSI
      ) {
        // 差戻かつログインユーザーが申請者であれば編集可
        this.isEditMode = false;
        this.isDisableExpensesList = false;
      } else if (
        this.isMine &&
        this.delegate.request.c_request_status == CONST_REQUEST_STATUS_MISINSEI
      ) {
        // 未申請かつログインユーザーが申請者かつ、最終更新者が申請者であれば編集可
        this.isEditMode = false;
        this.isDisableExpensesList = false;
      } else if (
        this.isMine &&
        this.isRewriteMisinsei &&
        !this.isLoginUserSettingApprovalUser
      ) {
        // 再編集ボタンを押された未申請かつ申請承認1～3のユーザーがいない場合は編集可能
        this.isEditMode = false;
        this.isDisableExpensesList = false;
      } else if (
        !this.isMine &&
        this.isRewriteMisinsei &&
        this.isLoginUserApproval
      ) {
        // 再編集ボタンを押された未申請であれば申請承認1～3のユーザーのみ編集可能
        this.isEditMode = false;
        this.isDisableExpensesList = false;
      }

      await this.sumCalc();

      //領収書画像の再読み込み
      this.showReceptImg = !this.showReceptImg;
      await this.delay(1000);
      this.showReceptImg = !this.showReceptImg;
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
      this.expensesList = [];
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  async updateLocalStatus() {
    this.isRewriteMisinsei =
      this.delegate.request.c_request_status ==
      CONST_REQUEST_STATUS_MISINSEI_REWRITE;

    // ログインユーザーが申請承認1～3に該当するか
    this.isLoginUserApproval =
      this.$store.state.id == this.staffMaster.c_staff_application_staff_id_1 ||
      this.$store.state.id == this.staffMaster.c_staff_application_staff_id_2 ||
      this.$store.state.id == this.staffMaster.c_staff_application_staff_id_3;

    this.rewriteFlg = false;
    this.isLoginUserSettingApprovalUser = true;
    if (
      this.staffMaster.c_staff_application_staff_id_1 == null &&
      this.staffMaster.c_staff_application_staff_id_2 == null &&
      this.staffMaster.c_staff_application_staff_id_3 == null
    ) {
      this.isLoginUserSettingApprovalUser = false;
    }
    // 承認済かつログインユーザーが申請者の申請承認1～3であれば再編集を可能とする
    if (
      this.delegate.request.c_request_status == CONST_REQUEST_STATUS_SYOUNINZUMI
    ) {
      if (
        this.isMine &&
        this.staffMaster.c_staff_application_staff_id_1 == null &&
        this.staffMaster.c_staff_application_staff_id_2 == null &&
        this.staffMaster.c_staff_application_staff_id_3 == null
      ) {
        // 申請承認1～3がいずれも未設定の場合は自身で再編集ボタンの押下が可能
        this.rewriteFlg = true;
      }
      if (
        this.$store.state.id == this.staffMaster.c_staff_application_staff_id_1
      ) {
        this.rewriteFlg = true;
      }
      if (
        this.$store.state.id == this.staffMaster.c_staff_application_staff_id_2
      ) {
        this.rewriteFlg = true;
      }
      if (
        this.$store.state.id == this.staffMaster.c_staff_application_staff_id_3
      ) {
        this.rewriteFlg = true;
      }
    }
  }
  async delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  /**
   * DOM連携用の変換処理　GET用。
   */
  async cnvData4Get() {
    Cl_common.logger("this.delegate4list.items4staffs");
    Cl_common.logger(this.delegate4list.items4staffs);
    //申請者
    this.domApplicantName = CommonStaff.cnvStaffNum2Name(
      this.delegate4list.items4staffs,
      this.delegate.request.c_staff_id
    );

    //起案日
    if (this.delegate.c_request_expenses_date_draft != null) {
      this.domStartDate = this.delegate
        .c_request_expenses_date_draft!.toString()
        .split("T")[0];
    }

    //仮払金額
    if (this.delegate.c_request_expenses_tmppay_price != null) {
      this.domTmppay_price = this.delegate.c_request_expenses_tmppay_price;
    }

    //精算金額
    if (this.delegate.c_request_expenses_total != null) {
      this.domPay_price = this.delegate.c_request_expenses_total.toString();
    }
  }

  /**
   * 承認に関するコンテンツを制御する
   */
  async chgAuthCont() {
    let loginStaffId = -1;

    switch (this.delegate.request.c_request_status) {
      case CONST_REQUEST_STATUS_SINSEITYU:
        //申請中
        //-----------
        store.commit("revStore");
        loginStaffId = store.state.id;
        if (
          (loginStaffId == this.delegate.request.c_request_1_approval &&
            this.delegate.request.c_request_1_approval_datetime == null) ||
          (loginStaffId == this.delegate.request.c_request_2_approval &&
            this.delegate.request.c_request_2_approval_datetime == null) ||
          (loginStaffId == this.delegate.request.c_request_3_approval &&
            this.delegate.request.c_request_3_approval_datetime == null)
        ) {
          //自身が承認者で未承認
          //--------
          this.fmShowConf = true;
          this.fmShowConfEx = false;
          this.fmShowSasimodosi = false;
          this.fmShowTorisage = false;
        } else {
          //自身が承認者でない、もしくは承認済み
          //--------
          this.fmShowConf = false;
          this.fmShowConfEx = true;
          this.fmShowSasimodosi = false;
          this.fmShowTorisage = false;
        }

        break;
      case CONST_REQUEST_STATUS_SASIMODOSI:
        //差戻
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = true;
        this.fmShowTorisage = false;
        break;
      case CONST_REQUEST_STATUS_SYOUNINZUMI:
        //承認済
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = false;
        this.fmShowTorisage = false;
        break;
      case CONST_REQUEST_STATUS_TORISAGE:
        //取下
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = false;
        this.fmShowTorisage = true;

        break;
      case CONST_REQUEST_STATUS_MISINSEI:
        //未申請
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = false;
        this.fmShowTorisage = false;

        break;
      case CONST_REQUEST_STATUS_MISINSEI_REWRITE:
        //未申請(再編集)
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = false;
        this.fmShowTorisage = false;

        break;
      default:
        throw new Error("不正なstatus");
    }
  }

  /**
   * データを更新する
   * 申請書用
   */
  async upd(isDel: boolean, isDisable: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoRequestsPutReqImple();
      let id = Cl_common.getParam("id");
      dto.c_request_id = Number(id);

      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_request_flag_del = 1;
      } else {
        //取下処理：取下フラグを立てる。
        dto.c_request_status = 4;
      }

      //API実行
      //-------
      await Cl_request.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "正常に削除されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に変更されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを更新する
   * 変更保存用
   * 一時保存・編集が可能な申請書で使用
   */
  async updNormal(isNoModal: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //バリデーション
      //-----------------
      this.errors = null;
      this.schemaAdd.validateSync({
        startDate: this.domStartDate,
      });

      this.schemaAdd_tmppayprice.validateSync({
        tmppayPrice: this.domTmppay_price,
      });

      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      //UI連携用変数からdelegateに戻す
      //---
      await this.cnvData4Add();

      let dto = Object.assign(
        new DtoRequestExpensessPutReqImple(),
        this.delegate
      );

      //一覧の変換メソッド実行
      let expensesListTmp: EntityRequestExpensesList[] = [];
      let EntityRequestExpensesTmp: EntityRequestExpensesList;
      for (let index = 0; index < this.expensesList.length; index++) {
        EntityRequestExpensesTmp = Object.assign(
          new EntityRequestExpensesList(),
          this.expensesList[index]
        );
        EntityRequestExpensesTmp.cnvDom2data();
        // this.expensesList[index].cnvDom2data();

        expensesListTmp.push(EntityRequestExpensesTmp);
      }

      dto.c_request_expenses_list = JSON.stringify(expensesListTmp);

      //API実行
      //-------
      const res = await Cl_requestexpenses.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定

      this.message4ModalSuccess = "正常に変更されました";

      //モーダルを表示
      if (!isNoModal) {
        const modal: any = this.$refs.Mo_modal_success;
        modal.showModal();
      }
    } catch (error) {
      if (isNoModal) {
        //noModalの場合、例外を呼び出し元に投げる
        throw error;
      } else {
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();

        Cl_common.logger(error);
      }
    } finally {
      if (!isNoModal) {
        //ボタン無効解除＋ローダー非表示
        //-----------------
        this.btnDisable = false;
        Array.from(panel).map((element: Element) => {
          element.classList.remove("enable-loader");
        });
      }
    }
  }

  /**
   * データを更新する
   * 承認・差戻用
   */
  async upd4Approval(isApproval: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //バリデーション
      // //-------

      /* *****************************************************
      仕様確認の為、コメントアウト。
      20231217_領収書がないと最終更新できない
      ***************************************************** */
      // //経費精算書は、領収書がないと最終承認できない。
      // store.commit("revStore");
      // const loginStaffId = store.state.id;
      // if (
      //   isApproval &&
      //   (this.delegate.request.c_request_3_approval == loginStaffId || //最終承認者が自分の場合
      //     (this.delegate.request.c_request_2_approval == loginStaffId &&
      //       this.delegate.request.c_request_3_approval == null) || //第二承認者が自分で、最終承認者がいない場合
      //     (this.delegate.request.c_request_1_approval == loginStaffId &&
      //       this.delegate.request.c_request_2_approval == null &&
      //       this.delegate.request.c_request_3_approval == null)) //第一承認者が自分で、第二承認者と最終承認者がいないの場合
      // ) {
      //   //領収書がない
      //   if (
      //     this.delegate.docfile == null ||
      //     this.delegate.docfile.url4Show == null ||
      //     this.delegate.docfile.url4Show == ""
      //   ) {
      //     //モーダルのメッセージを設定
      //     this.message4ModalErrorConf =
      //       "領収書が添付されていない場合、最終承認ができません";
      //     //モーダル表示
      //     const modal: any = this.$refs.Mo_modal_errorConf;
      //     modal.showModal();

      //     return;
      //   }
      // }
      // *****************************************************

      // //準備
      // //-------
      let dto = new DtoRequestsPutReqImple();
      let id = Cl_common.getParam("id");
      dto.c_request_id = Number(id);

      if (isApproval) {
        //承認
        dto.isApproval = 1;
      } else {
        //差戻
        dto.isApproval = 0;
      }

      //API実行
      //-------
      await Cl_request.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isApproval) {
        //削除処理：
        this.message4ModalSuccess = "正常に承認されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に差戻されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 承認申請実行
   */
  async approvalRequest() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      /* *****************************************************
      仕様確認の為、コメントアウト。
      20231217_領収書がないと最終更新できない
      ***************************************************** */
      // //経費精算書は、領収書がないと最終承認できない。
      // store.commit("revStore");
      // const loginStaffId = store.state.id;
      // if (
      //   //承認者が設定されておらず、申請=承認済みの場合
      //   this.delegate.request.c_request_1_approval == null &&
      //   this.delegate.request.c_request_2_approval == null &&
      //   this.delegate.request.c_request_3_approval == null
      // ) {
      //   //領収書がない
      //   if (
      //     this.delegate.docfile == null ||
      //     this.delegate.docfile.url4Show == null ||
      //     this.delegate.docfile.url4Show == ""
      //   ) {
      //     //モーダルのメッセージを設定
      //     this.message4ModalErrorConf =
      //       "領収書が添付されていない場合、最終承認ができません";
      //     //モーダル表示
      //     const modal: any = this.$refs.Mo_modal_errorConf;
      //     modal.showModal();

      //     return;
      //   }
      // }
      //*****************************************************

      //保存処理実行
      await this.updNormal(true);

      // //準備
      // //-------
      let dto = new DtoRequestsPutReqImple();
      let id = Cl_common.getParam("id");
      dto.c_request_id = Number(id);
      dto.isApprovalRequest = 1;

      //API実行
      //-------
      await Cl_request.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に承認申請されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //バリデーション
      //-----------------
      this.errors = null;
      this.schemaAdd.validateSync({
        startDate: this.domStartDate,
      });

      this.schemaAdd_tmppayprice.validateSync({
        tmppayPrice: this.domTmppay_price,
      });

      // this.schemaAdd_payprice.validateSync({
      //   payPrice: this.domPay_price,
      // });

      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      //UI連携用変数からdelegateに戻す
      //---
      await this.cnvData4Add();

      let dto = Object.assign(
        new DtoRequestExpensessPostReqImple(),
        this.delegate
      );

      //一覧の変換メソッド実行
      for (let index = 0; index < this.expensesList.length; index++) {
        this.expensesList[index].cnvDom2data();
      }

      dto.c_request_expenses_list = JSON.stringify(this.expensesList);

      //API実行
      //-------
      const res = await Cl_requestexpenses.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/shinsei_Keihiseisanedit",
        query: { id: res.c_request_id },
      });

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * 領収書を新たに登録する
   * Or_fileuploadにファイルが投入されると、このメソッドが呼ばれる。
   */
  @Watch("fileInfo")
  async add4Recept() {
    Cl_common.logger(this.fileInfo);
    if (this.fileInfo.size <= 0) {
      return;
    }

    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //バリデーション
      //-----------------

      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      //UI連携用変数からdelegateに戻す
      //---

      // docfileがあれば更新だし、なければPOST。文書管理画面と同じようにする。
      // UPDの場合全消しフラグをたてて、DocsPutを使う？

      let url4Upload = "";

      if (
        this.delegate.docfile != null &&
        this.delegate.docfile.c_doc_id != null
      ) {
        //更新
        let dto = new DtoDocsPutReqImple();

        dto.c_doc_id = this.delegate.docfile.c_doc_id;

        dto.c_doc_name = this.domStartDate + "起案　領収書";
        dto.c_staff_id = this.delegate.request.c_staff_id;
        dto.c_request_expenses_id = this.delegate.c_request_expenses_id;
        dto.c_doc_type = CONST_DOC_TYPE_RYOUSYUSYO;
        dto.c_doc_price = this.delegate.c_request_expenses_total;
        dto.c_doc_flag_issuer = 0;
        dto.c_doc_flag_del = 0;
        dto.c_doc_flag_enab = 1;
        dto.c_doc_flag_reserve = 1;

        dto.filename = this.fileInfo.name;
        dto.filetype = this.fileInfo.type;
        dto.filesize = this.fileInfo.size;

        Cl_common.logger("API実行");
        //API実行
        //-------
        const res = await Cl_doc.put(dto);

        Cl_common.logger(res);

        url4Upload = res.url!;
      } else {
        //登録
        let dto = new DtoDocsPostReqImple();

        dto.c_doc_name = this.domStartDate + "起案　領収書";
        dto.c_staff_id = this.delegate.request.c_staff_id;
        dto.c_request_expenses_id = this.delegate.c_request_expenses_id;
        dto.c_doc_type = CONST_DOC_TYPE_RYOUSYUSYO;
        dto.c_doc_price = this.delegate.c_request_expenses_total;
        dto.c_doc_flag_issuer = 0;
        dto.c_doc_flag_del = 0;
        dto.c_doc_flag_enab = 1;
        dto.c_doc_flag_reserve = 1;

        dto.filename = this.fileInfo.name;
        dto.filetype = this.fileInfo.type;
        dto.filesize = this.fileInfo.size;

        Cl_common.logger("API実行");
        //API実行
        //-------
        const res = await Cl_doc.post(dto);

        Cl_common.logger(res);

        url4Upload = res.url!;
      }

      //レスポンスの処理
      //-------
      //アップロード用のURLが返されたら、アップロード処理を行う。
      if (url4Upload == "") {
        this.message4ModalErrorConf = "ファイルのアップロードに失敗しました";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        return;
      } else {
        await axios.put(url4Upload, this.fileInfo.data);
      }

      //-------
      //編集画面のURL作成
      // this.$router.push({
      //   path: "/shinsei_Keihiseisanedit",
      //   query: { id: res.c_doc_id },
      // });

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "Keihiseisan";
      let id = Cl_common.getParam("id");
      dto.requestId = Number(id);
      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);

      //レスポンス処理
      //-------
      location.href = res.url;
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * DOM連携用の変換処理　ADD用。
   */
  async cnvData4Add() {
    //起案日
    if (this.domStartDate != undefined) {
      this.delegate.c_request_expenses_date_draft = new Date(this.domStartDate);
    }

    //仮払金額
    if (this.domTmppay_price != null) {
      this.delegate.c_request_expenses_tmppay_price = Number(
        this.domTmppay_price
      );
    }

    //精算金額
    if (this.domPay_price != null) {
      this.delegate.c_request_expenses_total = Number(this.domPay_price);
    }
  }

  /**
   * データ削除用のモーダルを表示
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf =
      "【" +
      this.delegate.c_request_id +
      "】" +
      this.delegate.request.c_request_name +
      "を削除します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }

  /**
   * 取り下げ用のモーダルを表示
   */
  async disableConf() {
    //モーダルのメッセージを設定
    this.message4ModalDisableConf =
      "【" +
      this.delegate.c_request_id +
      "】" +
      this.delegate.request.c_request_name +
      "を取り下げます。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_disableConf;
    modal.showModal();
  }

  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true, false);
  }
  /**
   * データを取り下げる
   */
  async disab() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4disableConf();
    this.upd(false, true);
  }

  /**
   * エクセル出力ボタンの表示・非表示を制御する。
   */
  isShowExportBtn() {
    if (!this.isEditMode) {
      return false;
    }

    //データがなければ非表示
    if (this.delegate == null || this.delegate.c_request_id == null) {
      return false;
    }

    //差戻かつ本人でない場合、非表示
    store.commit("revStore");
    const loginStaffId = store.state.id;
    if (
      this.delegate.request.c_request_status ==
        CONST_REQUEST_STATUS_SASIMODOSI &&
      this.delegate.request.c_staff_id != loginStaffId
    ) {
      return false;
    }

    //承認済みステータスであれば表示
    if (
      this.delegate.request.c_request_status == CONST_REQUEST_STATUS_SYOUNINZUMI
    ) {
      return true;
    }

    //一人でも承認して入れば表示
    if (
      this.delegate.request.c_request_1_approval_status ==
        CONST_APPROVAL_STATUS_SYOUNIN ||
      this.delegate.request.c_request_2_approval_status ==
        CONST_APPROVAL_STATUS_SYOUNIN ||
      this.delegate.request.c_request_3_approval_status ==
        CONST_APPROVAL_STATUS_SYOUNIN
    ) {
      return true;
    }

    // それ以外は非表示
    return false;
  }

  reriteConf() {
    //モーダルのメッセージを設定
    this.message4ModalRewriteConf =
      "申請番号:" +
      this.delegate.request.c_request_id +
      "　" +
      "を再編集するために未申請の状態に戻します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_rewiteConf;
    modal.showModal();
  }
  /**
   * 未申請状態に戻す
   */
  async rewrite() {
    this.closeModal4RewriteConf();

    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoRequestsPutReqImple();
      let id = Cl_common.getParam("id");
      dto.c_request_id = Number(id);
      dto.isRewrite = 1;

      //API実行
      //-------
      await Cl_request.put(dto);
      //レスポンスの処理
      //-------
      //モーダルのメッセージ
      this.message4ModalSuccess = "正常に変更されました";
      const modal: any = this.$refs.Mo_modal_success;

      modal.showModal();

      this.updateLocalStatus();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------

      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  /**
   * 国税庁のインボイス検索画面に遷移する
   */
  goToTaxSite() {
    if (this.domRegistNum != null) {
      window.open(
        "https://www.invoice-kohyo.nta.go.jp/regno-search/detail?selRegNo=" +
          this.domRegistNum
      );
    }
  }
  //----------------------
  //モーダル用メソッド
  //----------------------
  async showModal4Receipt(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_receipt;
    modal.showModal();
  }
  async closeModal4Receipt(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_receipt;
    modal.closeModal();
  }
  //-------
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }
  async closeModal4disableConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_disableConf;
    modal.closeModal();
  }
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
  async closeModal4RewriteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_rewiteConf;
    modal.closeModal();
  }
}
</script>

<style scoped>
input {
  width: 100%;
}

.headKeihi,
.footKeihi {
  text-align: center;
}
.tableKeihi tbody tr {
  border-bottom: 1px solid #ccc;
}

.tableKeihi td {
  border-right: 1px solid #ccc;
  height: 20px;
}
.tableKeihi tr > td:last-child {
  border-right: none;
}

.tableKeihi td input {
  background-color: #fff;
}

.keihiCont > input {
  border: none;
  width: 100%;
}

.cwK_2 {
  min-width: 160px;
  max-width: 160px;
}
.cwK_3 {
  /* width: 20%; */
}
.cwK_4 {
  /* width: 40%; */
}
.cwK_5 {
  /* width: 5%; */
  min-width: 60px;
  max-width: 60px;
}
.cwK_6 {
  /* width: 10%; */
}
.cwK_7 {
  min-width: 100px;
  max-width: 100px;
}
.titleMargin {
  margin: 15px 5px;
}

.titleKubetsu {
  border-radius: 0%;
  padding: 0.5rem;
}
.input-group-text {
  height: 30px;
  padding: 5px;
}

.notActive {
  background-color: rgb(229, 229, 229);
}
.notActive input {
  background-color: rgb(229, 229, 229) !important;
}

.isEdit input:disabled,
.isEdit textarea:disabled {
  background-color: #fff !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0 !important;
}

.tb_list {
  margin-bottom: 30px;
  margin-top: 30px;
  /* width: 49%; */
}

.tb_title {
  font-size: 15px;
  border: 1px #e9e9e9 solid;
  width: 8%;
  text-align: center;
  /* background-color: #eff4fc; */
}
.tb_list tr {
  border: 1px #e9e9e9 solid;
}
.tb_list td {
  border: 1px #e9e9e9 solid;
}
.tb_list .tb_det {
  width: 35%;
  padding-left: 7px;
}
.tb_list .tb_name {
  width: 10%;
  padding-left: 7px;
}
.tb_list .tb_num {
  width: 5%;
  text-align: center;
}

.notZeroTmppay {
  display: inline !important;
}

/* 経費精算書だけ横幅の関係でスマホサイズの時に出力ボタンを非表示 */
@media only screen and (max-width: 566px) {
  .keihiseisansyoExDl {
    display: none;
  }
}

/* //------------------- */
#header4Recept {
  height: 20px;
}
#body4Recept {
  height: calc(100vh - 178px);
  overflow: auto;
  padding-bottom: 20px;
}

#footer4Recept {
  position: fixed;
  bottom: 0;
  right: 10px;
  width: 98%;
  height: 100px;
  background-color: #fff;
  padding: 0;
  margin: 0;
  border-top: 1px solid rgb(229, 229, 229);
}

/* #header4Recept {
  height: 4vh;
  overflow: auto;
}
#body4Recept {
  height: 80vh;
  overflow: auto;
}
#footer4Recept {
  height: 5vh;
  overflow: auto;
  padding: 0;
  padding-right: 5px;
  padding-bottom: 5px;
  border-top: 1px solid rgb(229, 229, 229);
} */

#btnOpenRecept:disabled {
  color: #fff;
  background-color: #727b84;
  border-color: #6c757d;
}

@media (max-width: 575px) {
  #dzFlame {
    height: 200px !important;
  }
  #frame-img {
    max-height: 60vh !important;
  }
  #frame-img4None {
    height: 640px !important;
  }
}

/* 
//ソート機能
//------- 
*/

#sort4InvoiceHead:hover,
#sort4DateHead:hover {
  cursor: pointer;
  text-decoration: underline;
  opacity: 0.7;
}

.dispNone {
  display: none;
}
</style>
